import { createContext, useContext } from 'react'

import type { Scope } from '@/pages/teams/permissionQuota/types'

import type { PermissionForm, QuotaLimits } from './types'

type Ctx = {
  scope: Scope
  form: PermissionForm
  setForm: (next: PermissionForm | ((prev: PermissionForm) => PermissionForm)) => void
  teamDefaults?: PermissionForm
  loading?: boolean
  quotaLimits?: QuotaLimits
}

export function usePermissionForm() {
  const ctx = useContext(PermissionCtx)
  if (!ctx) throw new Error('PermissionFormContext not found')
  return ctx
}

const PermissionCtx = createContext<Ctx | null>(null)

export function PermissionFormProvider({
  value,
  children,
}: {
  value: Ctx
  children: React.ReactNode
}) {
  return <PermissionCtx.Provider value={value}>{children}</PermissionCtx.Provider>
}
